module.exports = __webpack_public_path__ + "img/ico_gaoshou.9f0df3d6.png";